import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

export default function PaymentSuccess() {
  const { refreshProfile } = useAuth();
  const navigate = useNavigate();
  const [refreshed, setRefreshed] = useState(false);

  useEffect(() => {
    // Give Stripe webhook a moment to process, then refresh profile
    const timer = setTimeout(async () => {
      await refreshProfile();
      setRefreshed(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, [refreshProfile]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#09090B] p-6">
      <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }}
        className="text-center max-w-md">
        <div className="w-20 h-20 rounded-full bg-[#22c55e]/10 border-2 border-[#22c55e] flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-10 h-10 text-[#22c55e]" />
        </div>
        <h1 className="font-heading text-3xl font-black text-white mb-2">You're Premium! ⚡</h1>
        <p className="text-[#A1A1AA] mb-8">
          Welcome to Stock Correlations Premium. Your β-Regression forecasts and Deep Pattern Matching are now active.
        </p>
        <Button onClick={() => navigate("/")} className="bg-[#22c55e] hover:bg-[#16a34a] text-black font-bold h-12 px-8">
          <Zap className="w-5 h-5 mr-2" /> Start Exploring
        </Button>
      </motion.div>
    </div>
  );
}
